import {createRoot, hydrateRoot} from 'react-dom/client';
import AboutMe from '../pages/AboutMe/AboutMe'
import "../index.css";
import "../pages/AboutMe/AboutMe.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<AboutMe {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <AboutMe {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).AboutMeVC = {mount, hydrate, unmount}